module.exports = __webpack_public_path__ + "img/rukavy_81_temne-modra.86cb7c3c.png";